import Alien from "../assets/avatars/Alien.svg"
import Cow from "../assets/avatars/Cow.svg"
import Giraffe from "../assets/avatars/Giraffe.svg"
import Lion from "../assets/avatars/Lion.svg"
import Monkey from "../assets/avatars/Monkey.svg"

import Robot from "../assets/avatars/Robot.svg"
import Astronaut from "../assets/avatars/Astronaut.svg"
import Donkey from "../assets/avatars/Donkey.svg"

export const avatars = [
    {
        image: Alien
    }, {
        image: Cow
    }, {
        image: Giraffe
    }, {
        image: Lion
    }, {
        image: Monkey
    },
    {
        image: Robot
    },
    {
        image: Donkey
    },
    {
        image: Astronaut
    },

]